import { listen, qs, qsa, toggle } from "@fluorescent/dom";
import { section } from "@/glow";

const selectors = {
  update: "[data-update-cart]",
  item: ".cart-template__item",
  updateInput: '[name="updates[]"]',
  loadingSpinner: ".cart__update-loading",
  cartItemsJSON: "[data-cart-contents]",
};

section("cart", {
  onLoad() {
    this.items = qsa(selectors.item, this.container);
    this.updateButton = qs(selectors.update, this.container);
    this.loadingSpinner = qs(selectors.loadingSpinner, this.container);
    this.events = [
      listen(this.updateButton, "click", this.handleClick.bind(this)),
    ];
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },

  handleClick(e) {
    e.preventDefault();
    this.toggleLoader();

    return this.updateQuantities()
      .then(() => this.fetchSection(this.id))
      .then((section) => this.applyDomUpdate(section))
  },

  async updateQuantities() {
    const changedItems = this.dirtyCartItems();

    // Sequential requests to cart/change are needed
    // Parallel requests override eachothers quantity changes
    for (const [id, quantity] of changedItems) {
      await fetch(theme.routes.cart.change, {
        method: "POST",
        redirect: "manual",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, quantity }),
      })
    }
  },

  fetchSection(sectionId) {
    return fetch(`${window.Shopify.routes.root}?sections=${sectionId}`)
      .then(res => res.json())
      .then(res => res[sectionId])
  },

  applyDomUpdate(section) {
    const parser = new DOMParser();
    const updatedSectionHTML = parser
      .parseFromString(section, "text/html")
      .querySelector('div[data-section-type=cart]')
      .innerHTML;

    this.onUnload();
    this.container.innerHTML = updatedSectionHTML;
    this.onLoad();
  },

  toggleLoader() {
    toggle([this.updateButton, this.loadingSpinner], 'hidden');
  },

  dirtyCartItems() {
    const cleanItems = JSON.parse(qs(selectors.cartItemsJSON, this.container)?.innerHTML || "{}")

    return this.items.reduce((acc, item) => {
      const { itemKey } = item.dataset
      const quantityInput = qs(selectors.updateInput, item);
      const quantity = parseInt(quantityInput.value, 10);

      return (quantity !== cleanItems[itemKey])
        ? acc.concat([[itemKey, quantity]])
        : acc
    }, [])
  }
});
